module.exports = __webpack_public_path__ + "img/home.1d406270.svg";